import { createReducer } from 'src/helpers/reducer';
import actionsTypes from './actionTypes';
import { ICreditCardsState } from './types';

const initState: ICreditCardsState = {
  isLoading: false,
};

function onProcessActionRequest(state: ICreditCardsState) {
  return {
    ...state,
    isLoading: true,
  };
}

function onProcessActionSuccess(state: ICreditCardsState) {
  return {
    ...state,
    isLoading: false,
  };
}

function onProcessActionError(state: ICreditCardsState) {
  return {
    ...state,
    isLoading: false,
  };
}

export default createReducer(initState, {
  [actionsTypes.PROCESS_ACTION_REQUEST]: onProcessActionRequest,
  [actionsTypes.PROCESS_ACTION_SUCCESS]: onProcessActionSuccess,
  [actionsTypes.PROCESS_ACTION_ERROR]: onProcessActionError,
});
